export default function Elem({top, left, src}){
    return(
        <div style={{position: 'absolute', left: `${left}px`, top: `${top}px`}}>
            <img className="penche" width={'150px'} height={'auto'} alt="Element" src={src}/>
        </div>
    )
}